$(document).ready(function () {
  
  let ccThumbsNavSlider;
  let ccThumbsMainSlider;

  function toggleSwiper() {
    const ccThumbsNavSwiper = document.querySelector('.cc-thumbs-nav');
    const ccThumbsMainSwiper = document.querySelector('.cc-thumbs');
    if (!ccThumbsNavSwiper || !ccThumbsMainSwiper) return;
    
    if (window.innerWidth <= 860) {
      if (!ccThumbsNavSlider || !ccThumbsMainSlider) {
        ccThumbsNavSlider = new Swiper('.cc-thumbs-nav', {
          slidesPerView: 4,
          spaceBetween: 10,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });
      
        ccThumbsMainSlider = new Swiper('.cc-thumbs', {
          slidesPerView: 1,
          watchSlidesProgress: true,
          thumbs: {
            swiper: ccThumbsNavSlider,
          },
        });
      }
    } else {
      if (ccThumbsNavSlider || ccThumbsMainSlider) {
        ccThumbsNavSlider.destroy(true, true);
        ccThumbsMainSlider.destroy(true, true);
        ccThumbsNavSlider = null;
        ccThumbsMainSlider = null;
      }
    }
  }
  
  // Initial check
  toggleSwiper();
  // Re-check on window resize
  window.addEventListener("resize", toggleSwiper);


  $('body').on('click', '[data-product-details-anchor]', function () {

    $([document.documentElement, document.body]).animate({
      scrollTop: $('[data-product-details-anchor]').offset().top - 75
    }, 500);

  });
  $.ajax({
    url: '/pages/fit-guide',
    type: 'GET',
    success: function (data) {
      var f = 0;
      var f_found = false;
      for (f = 0; f < ccFitGuide.length; f++) {
        if (!f_found) {
          var checkGuide = $(data).find('div[data-html="' + ccFitGuide[f] + '"]');
          if (checkGuide.length > 0) {
            f_found = true;
            $('[data-description-fitguide-accordion]').html(checkGuide.html());
            $('[data-description-fitguide-accordion] .fit-guide__image').removeAttr("srcset");
            $('[data-fit-desktop]').html(checkGuide.html());
            $('[data-fit-desktop] .fit-guide__image').removeAttr("srcset");
          }
        }
      }
    }
  });
  $("body").on('click', '[data-description-accordion-trigger]', function () {
    $('[data-description-fitguide-accordion] .fit-guide__image').removeAttr("srcset");
    $(this).next().toggle().parent().toggleClass('accordion--active');
  });

  const productSelect = document.querySelector('#product-select');

  function selectCallback(variant, selector) {
    if (variant) {
      if (variant.available) {
        // Selected a valid variant that is available.
        $('#rx-atc').show();
        $('#rx-atc').removeClass('hidden');
        $('.shopify-payment-button').show();
        $('#BISC_trigger').hide();
      } else {
        // Variant is sold out.
        $('#BISC_trigger').show();
        $('#BISC_trigger').removeClass('hidden');
        // $('#rx-atc').hide();
        // $('.shopify-payment-button').hide();
      }
    } else {
      // variant doesn't exist.
      $('.product-form .button--primary').val('Unavailable').addClass('disabled').attr('disabled', 'disabled').fadeTo(200, 0.5);
    }
  }

  if (productSelect) {
    new Shopify.OptionSelectors("product-select", {
      product: theProductJson,
      onVariantSelected: selectCallback
    });

    var firstAvailableVariant = theProductJson.variants.find(function (variant) {
      return variant.available;
    });

    if (firstAvailableVariant) {
      var originalInput = document.querySelector('input[name="id"]');
      if (originalInput) {
        originalInput.value = firstAvailableVariant.id;
      }
      selectCallback(firstAvailableVariant, null);
      productSelect.value = firstAvailableVariant.id;
    } else {
      document.getElementById('rx-atc').classList.add('hidden');
      document.getElementById('rx-atc').style.display = 'none';
      document.querySelector('.shopify-payment-button').style.display = 'none';
      document.getElementById('BISC_trigger').classList.remove('hidden');
      document.getElementById('BISC_trigger').style.display = 'block';
    }
  }

  if ($('#product-select-option-0 option').length > 1) {
    var allProductData = theProductJson;
    if (allProductData.type == "Snow Helmet") {
      $('#product-variants').prepend('<div id="snow-voptions"><label>SIZE: <span></span></label></div>');
      var countF = true;
      $('#product-select-option-0 option').each(function () {
        var sClass = "snow-option";
        if (countF) {
          sClass = "snow-option active";
          $('#snow-voptions span').text($(this).val());
          countF = false;
        }
        var optionCheck = $(this).val();
        if (optionCheck.charAt(0).toLowerCase() == 's') {
          $('#snow-voptions').append('<button type="button" class="' + sClass + '" data-val="' + optionCheck + '">S</button>');
        } else if (optionCheck.charAt(0).toLowerCase() == 'm') {
          $('#snow-voptions').append('<button type="button" class="' + sClass + '" data-val="' + optionCheck + '">M</button>');
        } else if (optionCheck.charAt(0).toLowerCase() == 'l') {
          $('#snow-voptions').append('<button type="button" class="' + sClass + '" data-val="' + optionCheck + '">L</button>');
        }
        var i = 0;
        for (i = 0; i < allProductData.variants.length; i++) {
          if (allProductData.variants[i].title == optionCheck) {
            if (!allProductData.variants[i].available) {
              $('[data-val="' + optionCheck + '"]').addClass('unavailable');
            }
          }
        };

      });
      $('.shopify-section.product #product-variants').show();
      $('.shopify-section.product').on('click', '.snow-option', function () {
        $('.shopify-section.product .snow-option').removeClass('active');
        $(this).addClass('active');
        var newLabel = $(this).attr('data-val');
        $('#snow-voptions span').text(newLabel);
        $('#product-select-option-0').val(newLabel).change();

      });
    }
  }

  
  $('.cc-thumbs .thumb-wrap').click(function () {
    var newMain = $(this).attr('data-main');
    $('.cc-main-photo img').attr('src', newMain);
    $('.cc-thumbs .thumb-wrap').removeClass('active');
    $(this).addClass('active');
    $('.cc-main-photo').show();
    if ($(window).width() > 860) {
      $('.cc-3d-view').hide();
    }

    if (!$('.product-images').hasClass('fullscreen')) {
      if ($(window).width() > 860) {
        $('.product-images').addClass('fullscreen');
        $('body').css('overflow-y', 'hidden');
      }
    }
  });
  
  $('#closeFullscreen').on('click', function () {
    $('.product-images').removeClass('fullscreen');
    $('body').css('overflow-y', 'auto');
  });
  $('.cc-thumbs .thumb-wrap').hover(function () {
    var newMain = $(this).attr('data-main');
    $('.cc-main-photo img').attr('src', newMain);
    $('.cc-thumbs .thumb-wrap').removeClass('active');
    $(this).addClass('active');
    $('.cc-main-photo').show();
    if ($(window).width() > 860) {
      $('.cc-3d-view').hide();
    }
  }, function () { });
  $('.product-images__action-expand').click(function () {
    $('.static-product__image-details').toggleClass('expanded');
  });
  $('.product-images__action-close').click(function () {
    $('.static-product__image-details').toggleClass('expanded');
  });
  $('.up-button a').click(function (e) {
    e.preventDefault();
    if ($(this).hasClass('selected')) {
      var remoteSend = $(this).attr('data-variant-id');
      var newQuant = parseInt($(this).attr('data-quantity')) - 1;
      var myS = $(this);
      var posting = $.post("/cart/change.js", {
        quantity: newQuant,
        id: remoteSend
      }, function (data) {
        myS.attr('data-quantity', newQuant);
      }, "json");
      $(this).removeClass("selected");
      var cCount = $('.header-icons__icon-badge').attr('data-cart-count');
      var cCount = parseInt(cCount) - 1;
      $('.header-icons__icon-badge').attr('data-cart-count', cCount);
      $('span.up-button__add', this).text('Add -');
      $(this).parent().siblings(".up-price").css('color', '#6D7278');
    } else {
      var remoteSend = $(this).attr('data-variant-id');
      var myS = $(this);
      var posting = $.post("/cart/add.js", {
        quantity: 1,
        id: remoteSend
      }, function (data) {
        myS.attr('data-quantity', data.quantity);
      }, "json");
      $(this).addClass("selected");
      var cCount = $('.header-icons__icon-badge').attr('data-cart-count');
      var cCount = parseInt(cCount) + 1;
      $('.header-icons__icon-badge').attr('data-cart-count', cCount);
      $('span.up-button__add', this).text('Added -');
      $(this).parent().siblings(".up-price").css('color', '#07B1FF');
    }
  });
  if (typeof upsellSale == 'function') {
    upsellSale();
  }

  $('#BISC_trigger').on('click', function () {
    const bisID = document.querySelector('input[name="id"]').value;
    BISPopover.show({
      variantId: bisID
    });
  });

  var queryString = window.location.search;
  var urlParams = new URLSearchParams(queryString);
  var sizeParam = urlParams.get('size');
  if (sizeParam) {
    $('#snow-voptions [data-val="' + sizeParam + '"]').trigger("click");
  }
  $('.spin-trigger a').on('click', function () {
    $('.cc-main-photo').hide();
    $('.cc-3d-view').show();
    $('.cc-3d-view model-viewer').attr('reveal', 'auto');
    $('.thumb-wrap').removeClass('active');
    $('.spin-trigger-d.cc-m').show();
    $('.spin-trigger.cc-m').hide();

  });
  $('.spin-trigger-d a').on('click', function () {
    $('.cc-main-photo').show();
    $('.cc-3d-view').hide();
    $('.spin-trigger-d.cc-m').hide();
    $('.spin-trigger.cc-m').show();
  });

  new Swiper(".frames-carousel__inner", {
    slidesPerView: 3,
    slidesPerGroup: 3,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      500: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      }
    },
  });

  new Swiper("#ctl-slider", {
    slidesPerView: 1,
    slidesPerGroup: 1,
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    navigation: {
      enabled: false
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      769: {
        navigation: {
          enabled: true,
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      }
    },
  });

  $('#RXbuilder [data-type]').click(function () {
    var theType = $(this).attr('data-type');
    if (window.innerWidth < 769) {
      $("#RXbuilder #step2_single .swiper-button-prev").show();
      $("#RXbuilder #step2_single .swiper-button-next").show();
    }
    if (!($('.lensImages').hasClass('swiper-initialized'))) {
      new Swiper(".lensImages", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        speed: 450,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      })
    };
  });

  function lensImagesToggleNavigation() {
    if (window.innerWidth < 769) {
      if (($('.lensImages').hasClass('swiper-initialized'))) {
        $("#RXbuilder #step2_single .swiper-button-prev").show();
        $("#RXbuilder #step2_single .swiper-button-next").show();
      };
    } else {
      $("#RXbuilder #step2_single .swiper-button-prev").hide();
      $("#RXbuilder #step2_single .swiper-button-next").hide();
    }
  }
  lensImagesToggleNavigation();
  window.addEventListener("resize", lensImagesToggleNavigation);
  
  if (onloadLens) {
    if (!($('.lensImages').hasClass('swiper-initialized'))) {
      new Swiper(".lensImages", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        speed: 450,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      })
    };
  }

});
const accss = document.querySelectorAll("#view2-accordion button.accordion");

accss.forEach(accordionItems => {
  accordionItems.addEventListener("click", (e) => {
    e.preventDefault();
    if (accordionItems.classList.contains('active')) {
      accordionItems.classList.remove("active");
    }
    else {
      accordionItems.classList.add("active");
    }
  });
});

//Sticky ATC
const elementTarget = document.getElementById("atc-trigger-wrap");
const stickyBar = document.getElementById("shopify-section-product-sticky-atc");

// changed mutation observer because of strange issue in Safari. Needed to compensate for the height of the sticky bar to prevent flickering.
document.addEventListener('scroll', function () {
  let elementTargetRect = elementTarget.getBoundingClientRect();
  let stickyHeight = stickyBar.offsetHeight;
  if (elementTargetRect.bottom - stickyHeight <= 0) {
    !stickyBar.classList.contains('sticky') ? stickyBar.classList.add('sticky') : null
  } else {
    stickyBar.classList.contains('sticky') ? stickyBar.classList.remove('sticky') : null
  }
})
